import Vue from 'vue'
import VeeValidate from 'vee-validate'

const dict = {
  custom: {
    site_url: {
      required: 'נא להזין את כתובת האתר.',
      url: 'כתובת האתר שהוזנה אינה תקינה.',
    },
    email: {
      required: 'נא להזין דואר אלקטרוני.',
      email: 'שדה דואר אלקטרוני אינו תקין.',
    },
    terms: {
      required: 'נא לקרוא ולאשר תנאי שימוש ומדיניות פרטיות.',
    },
    current_password: {
      required: 'נא להזין סיסמה נוכחית.',
    },
    password: {
      required: 'נא להזין סיסמה.',
    },
    new_password: {
      required: 'נא להזין סיסמה.',
    },
    confirm_password: {
      required: 'נא להזין אישור סיסמה.',
      confirmed: 'הסיסמאות אינן תואמות.',
    },
    first_name: {
      required: 'נא להזין שם פרטי.',
    },
    last_name: {
      required: 'נא להזין שם משפחה.',
    },
  }
}

VeeValidate.Validator.localize('en', dict)

const config = {
  events: '',
}

Vue.use(VeeValidate, config)



// WEBPACK FOOTER //
// ./src/plugins/vee-validate.js